import CellHOC from '@platform/react/hoc/list/cell'
import OverflowTooltip from 'ui/Element/Text/OverflowTooltip'
import { Typography } from '@mui/material'

/**
 * Intended to display the name of the recipient of a cart.
 *
 * @param {Object} props    element's properties
 * @param {Object} classes  element's style classes
 *
 * @returns {JSX.Element}
 */
const ListItemCellCartRecipient = (classes, props = {}) => {
  const { recipientData: { name = null } = {} } = props

  return (
    <OverflowTooltip
      component={Typography}
      variant={'14/medium'}
      color={'white.contrastText'}
    >
      {name || '-'}
    </OverflowTooltip>
  )
}

export default CellHOC(ListItemCellCartRecipient)
